import React from 'react';

export const LightingCategory = (props) => (
    <svg {...props} viewBox="0 0 20 26" fill="none">
        <path d="M14.1499 21.8C14.1499 24.1 12.2499 26 9.9499 26C7.6499 26 5.7499 24.1 5.7499 21.8V20.6H14.0499V21.8H14.1499ZM5.0499 17.7H14.8499L16.6499 16C18.3499 14.3 19.3499 12 19.3499 9.4C19.3499 6.8 18.3499 4.5 16.6499 2.8C14.9499 1.1 12.5499 0 10.0499 0C7.5499 0 5.0499 1 3.3499 2.7C1.6499 4.4 0.649902 6.8 0.649902 9.4C0.649902 12 1.6499 14.3 3.3499 16L5.0499 17.7Z" />
    </svg>
);

export default LightingCategory;
